<template>
  <div class="grid">
    <div v-if="search" class="xs-12">
      <InputSelect v-model="selectedFilter" class="webinar-select-box" placeholder="Filtra per tipologia">
        <option v-for="type in eventTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
      </InputSelect>
    </div>
    <div v-for="(item, key) in filteredEvents" :key="key" :class="columns" class="dea-event-wrapper">
      <CardEvent
        class
        columns
        card-layout="card"
        :event="item"
        :legs="item.legs"
        @save-bookmark="saveBookmark"
        @delete-bookmark="deleteBookmark"
      />
    </div>
  </div>
</template>

<script>
import InputSelect from "@/components/elements/InputSelect";
import bookmarksSetup from "@/components/mixins/bookmarksSetup";
import CardEvent from "./CardEvent";

export default {
  name: "EventsList",
  components: { CardEvent, InputSelect },
  mixins: [bookmarksSetup],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: Boolean,
      default: false,
    },
    child: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      columns: "xs-12 s-6 m-4",
      filteredEvents: this.items,
      selectedFilter: null,
      bookmarksSave: "saveEvent",
      bookmarksGet: "getEvents",
      bookmarkType: "event",
    };
  },
  computed: {
    eventTypes() {
      const typesList = this.items.map(item => {
        return { id: item.type, name: item.type_label };
      });
      // make list unique: they are objects so they must be compared by their string representation
      return Array.from(new Set(typesList.map(object => JSON.stringify(object)))).map(string => JSON.parse(string));
    },
  },
  watch: {
    items() {
      this.filteredEvents = this.items;
    },
    selectedFilter() {
      this.filteredEvents = this.items.filter(item => item.type === this.selectedFilter);
    },
  },
};
</script>
